import * as React from "react";
import { useCallback, useContext, useMemo } from "react";
import { Form, Formik } from "formik";
import isFunction from "lodash/isFunction";
import { onInitializingTimerange } from "views/components/TimerangeForForm";
import FormWarningsContext from "contexts/FormWarningsContext";
import validate from "views/components/searchbar/validate";
import usePluginEntities from "hooks/usePluginEntities";
import useUserDateTime from "hooks/useUserDateTime";
import useHandlerContext from "views/components/useHandlerContext";
import useSearchBarSubmit from "views/components/searchbar/useSearchBarSubmit";
const _isFunction = (children) => isFunction(children);
const SearchBarForm = ({
  initialValues,
  limitDuration,
  onSubmit,
  children,
  validateOnMount = true,
  formRef = void 0,
  validateQueryString
}) => {
  const { formatTime, userTimezone } = useUserDateTime();
  const pluggableSearchBarControls = usePluginEntities("views.components.searchBar");
  const { setFieldWarning } = useContext(FormWarningsContext);
  const _initialValues = useMemo(() => {
    const { timerange, ...rest } = initialValues;
    return {
      ...rest,
      timerange: onInitializingTimerange(timerange, formatTime)
    };
  }, [formatTime, initialValues]);
  const { enableReinitialize, onSubmit: _onSubmit } = useSearchBarSubmit(_initialValues, onSubmit);
  const handlerContext = useHandlerContext();
  const _validate = useCallback(
    (values) => validate(
      values,
      limitDuration,
      setFieldWarning,
      validateQueryString,
      pluggableSearchBarControls,
      formatTime,
      handlerContext,
      userTimezone
    ),
    [
      limitDuration,
      setFieldWarning,
      validateQueryString,
      pluggableSearchBarControls,
      formatTime,
      handlerContext,
      userTimezone
    ]
  );
  return /* @__PURE__ */ React.createElement(
    Formik,
    {
      initialValues: _initialValues,
      enableReinitialize,
      onSubmit: _onSubmit,
      innerRef: formRef,
      validate: _validate,
      validateOnBlur: false,
      validateOnMount
    },
    (...args) => /* @__PURE__ */ React.createElement(Form, null, _isFunction(children) ? children(...args) : children)
  );
};
export default SearchBarForm;
